import { AccountInfoData, LspModuleData } from 'types';

const normalizeName = (value?: string) => (value || '').trim().toLowerCase();

const isActiveModule = (module?: LspModuleData) => {
  if (!module || module.isActive === false) {
    return false;
  }

  if (module.endsAt) {
    const endsAt = new Date(module.endsAt);
    if (!Number.isNaN(endsAt.getTime()) && endsAt.getTime() <= Date.now()) {
      return false;
    }
  }

  return true;
};

const hasActiveModule = (accountInfo: AccountInfoData | undefined, name: string) =>
  (accountInfo?.allowedModules ?? []).some(
    (module) => normalizeName(module.name) === name && isActiveModule(module),
  );

/** Farm-scoped entitlements from auth account-info (same signals as app selection). */
export const hasLivestockProductAccess = (accountInfo?: AccountInfoData) =>
  accountInfo?.hasLspAccount === true;

export const hasBoardProductAccess = (accountInfo?: AccountInfoData) =>
  accountInfo?.hasBoardAccount === true;

export const hasCropsProductAccess = (accountInfo?: AccountInfoData) => {
  if (accountInfo?.hasCropsAccount === true) {
    return true;
  }

  return hasActiveModule(accountInfo, 'vaxt');
};

export const countFarmProducts = (accountInfo?: AccountInfoData) =>
  Number(hasBoardProductAccess(accountInfo))
  + Number(hasCropsProductAccess(accountInfo))
  + Number(hasLivestockProductAccess(accountInfo));
